import { useMutation } from '@tanstack/react-query';
import { toast } from '@huspy/forge/shared';
import { clientsApi } from '@modules/clients/entities/client/api';
import queryClient from '@app/queryClient';
import { useTranslation } from 'react-i18next';
import useFeatureFlags from '@modules/core/hooks/useFeatureFlags';
import { AddUpdateClientRequestDTO } from '../api/dto/addUpdateClient.dto';

const useAddClient = (companyId?: string) => {
  const { t } = useTranslation();
  const { isFeatureActive } = useFeatureFlags();

  const {
    error, mutate, isPending, mutateAsync,
  } = useMutation({
    mutationKey: ['addClient'],
    mutationFn: (body: AddUpdateClientRequestDTO) => (
      isFeatureActive('clients.companyClients') && companyId
        ? clientsApi.addCompanyClient(companyId, body)
        : clientsApi.addClient(body)),
    onSuccess: (_) => {
      queryClient.refetchQueries({ queryKey: ['clientsList'] });
      toast('info', { message: t('clients.addClient.clientAdded') });
    },
    onError: () => {
      toast('error', { message: t('clients.addClient.clientCreationFailed') });
    },
  });

  return {
    mutate, error, isPending, mutateAsync,
  };
};

export default useAddClient;
